import { render, staticRenderFns } from "./videoLiveList.vue?vue&type=template&id=703dc29c&scoped=true"
import script from "./videoLiveList.vue?vue&type=script&lang=js"
export * from "./videoLiveList.vue?vue&type=script&lang=js"
import style0 from "./videoLiveList.vue?vue&type=style&index=0&id=703dc29c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703dc29c",
  null
  
)

export default component.exports